export const check = ({getters}, role) => {
  return getters[role]
}

